import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index/index'
import privacy_agreement from '@/view/index/privacy-agreement'
import user_agreement from '@/view/index/user-agreement'
import zsbindex from '@/view/zsb/index'
import zsbprivacy_agreement from '@/view/zsb/privacy-agreement'
import zsbuser_agreement from '@/view/zsb/user-agreement'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '大学好课',
      component: index
    },
    {
      path: '/privacy-agreement',
      name: '大学好课-隐私协议',
      component: privacy_agreement
    },
    {
      path: '/user-agreement',
      name: '大学好课-用户协议',
      component: user_agreement
    },
    {
      path: '/zsb',
      name: '考尚拉专升本',
      component: zsbindex
    },
    {
      path: '/zsb/privacy-agreement',
      name: '考尚拉专升本-隐私协议',
      component: zsbprivacy_agreement
    },
    {
      path: '/zsb/user-agreement',
      name: '考尚拉专升本-用户协议',
      component: zsbuser_agreement
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js